import axios from "axios";
import toast from "react-hot-toast";
import i18n from "i18n";

export const BASE_URL = process.env.REACT_APP_API_URL;

// Debounce 403 toast to prevent multiple toasts when several API calls fail simultaneously
let lastPermissionToastTime = 0;
const PERMISSION_TOAST_DEBOUNCE_MS = 2000;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

const axiosPublicInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem('nimax_auth_token');

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
  
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if user data is still present (real session expiry vs intentional logout)
      const hasUserData = localStorage.getItem('nimax_user');
      
      localStorage.removeItem('nimax_auth_token');

      // Only show session expired message if user was logged in (not during intentional logout)
      if (hasUserData) {
        localStorage.setItem('nimax_auth_expired', 'true');
      }

      if(!window.location.href.includes("/login")) {
        window.location.href = '/login';
      }
    }

    if (error.response?.status === 403) {
      // Only show toast for user-initiated actions (mutations), not for GET requests on page load
      const method = error.config?.method?.toUpperCase();
      const isMutation = method && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);

      if (isMutation) {
        // Debounce to prevent multiple toasts when several API calls fail simultaneously
        const now = Date.now();
        if (now - lastPermissionToastTime > PERMISSION_TOAST_DEBOUNCE_MS) {
          toast.error(i18n.t('ERROR_PERMISSION_DENIED'));
          lastPermissionToastTime = now;
        }
      }
      // Mark as handled so components don't show duplicate error toasts
      error.isPermissionError = true;
    }

    return Promise.reject(error);
  }
);

export {
  axiosInstance,
  axiosPublicInstance,
}
